var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cx from 'clsx';
import { getSpacingClasses } from '../../utils/spacings';
import { useColumnLayout } from '../columns/Columns';
import { getColumnWidthClasses } from './Column.utils';
import { baseColumnVariants, baseGutterVariants, collapsedVariants, responsiveColumnVariants, responsiveGutterVariants, } from './Column.css';
export const Column = React.forwardRef(function Column(_a, ref) {
    var { as, children, className, width = 'auto' } = _a, rest = __rest(_a, ["as", "children", "className", "width"]);
    const { collapseBelow, spacing } = useColumnLayout();
    const Component = as || 'div';
    const spacingClass = React.useMemo(() => getSpacingClasses(spacing, baseGutterVariants, responsiveGutterVariants), [spacing]);
    const widthClass = React.useMemo(() => getColumnWidthClasses(width, baseColumnVariants, responsiveColumnVariants), [width]);
    return (_jsx(Component, Object.assign({ className: cx(spacingClass, collapseBelow && collapsedVariants[collapseBelow], widthClass, className) }, rest, { ref: ref, children: children })));
});
